export const USERS_REQUEST = "USERS_REQUEST";
export const USERS_REVIEW_REQUEST = "USERS_REVIEW_REQUEST";
export const USERS_RECEIVE = "USERS_RECEIVE";
export const REVIEWS_RECEIVE = "REVIEWS_RECEIVE";
export const USERS_DEACTIVATE = "USERS_DEACTIVATE";
export const USERS_ACTIVATE = "USERS_ACTIVATE";
export const USERS_DEACTIVATE_COMPLETED = "USERS_DEACTIVATE_COMPLETED";
export const USERS_ACTIVATE_COMPLETED = "USERS_ACTIVATE_COMPLETED";
